const checkIntervalMs = 500;

export default function (widget) {
    const env = widget.env;

    let _heightMonitor;

    const fuzz = 10;

    const _start = function () {
        if (!_heightMonitor) {
            const wrapper = env.wrapperElm;
            const container = env.containerElm;
            const inlined = !env.iframe;
            const mWidth = inlined ? 'maxWidth' : 'minWidth';
            _heightMonitor = setInterval(function () {
                const parent = wrapper.parentNode;
                if (parent) {
                    const widgetHeight = (inlined ? container : (container.firstChild || {})).scrollHeight || 0;
                    if (inlined || wrapper.scrollHeight === widgetHeight) {
                        const parentHeight = parent.offsetHeight || 0;
                        const delta = widgetHeight - parentHeight;
                        const _lastScaleBy = (wrapper._lastScaleBy || 1);
                        if (
                            (delta < -fuzz && _lastScaleBy < 1) ||
                            (delta > fuzz && _lastScaleBy > 0.1 && wrapper.offsetWidth > 250)
                        ) {
                            const mapElm = container.querySelector('.' + widget.widgetClass + '__map-wrapper');
                            if (mapElm) {
                                const mapElmH = mapElm.offsetHeight;
                                const scaleBy = Math.min(1, Math.max(_lastScaleBy * (mapElmH - delta) / mapElmH, 0.1));
                                wrapper.style[mWidth] = (100 * scaleBy) + '%';
                                wrapper._lastScaleBy = scaleBy;
                            }
                        }
                    }
                }
            }, checkIntervalMs);
        }
    };


    const _stop = function () {
        if (_heightMonitor) {
            clearInterval(_heightMonitor);
            _heightMonitor = undefined;
        }
    };


    const _defaultStart = widget.start;
    widget.start = function () {
        _defaultStart.call(widget);
        setTimeout(function () { // can we skip this timeout?
            _start();
        }, 100);
    };
    const _defaultDestroy = widget.destroy;
    widget.destroy = function () {
        _defaultDestroy.call(widget);
        _stop();
    };


    return widget;
};
